export default "<p>logout works!</p>\n";